import { isWaiverQuestion } from '../../models/survey';
import { getQuestionsCollection } from '../../selectors/survey/pureSelectors';
import { CheckoutState } from '../../state';

export const hasWaiverQuestions = (state: CheckoutState) =>
    Object.values(getQuestionsCollection(state)).some((question) =>
        isWaiverQuestion(question.type),
    );
